import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  GoogleAuthProvider,
  connectAuthEmulator,
} from "firebase/auth";
import { Capacitor } from "@capacitor/core";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

// Auth — Phase 1 (Auth Foundation).
// `initializeApp` stays synchronous; no dynamic imports (PATTERNS §1).
//
// Sul nativo NON si usa getAuth: dentro una WKWebView la persistenza che
// sceglie da solo non funziona, e il primo callback di onAuthStateChanged non
// arriva mai. L'app resta allora sul caricatore «Puzzly», perche' `authReady`
// si accende proprio su quel callback. Con indexedDBLocalPersistence dichiarata
// a mano l'auth parte e lo stato arriva. (#40)
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

// Google provider. `prompt: "select_account"` forces account chooser so users
// on shared devices don't get silently signed back into a stale account.
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Cloud Functions client bound to europe-west1, the region of the deployed functions.
export const functions = getFunctions(app, "europe-west1");

// Cloud Storage — used to upload recorded video reactions so a share link can be
// emailed to the puzzle owner (reactionService.js). Bucket comes from
// REACT_APP_FIREBASE_STORAGE_BUCKET.
export const storage = getStorage(app);

// Local emulators — opt-in with REACT_APP_USE_EMULATORS=true (e.g. for QA of the
// creator without writing to production). Ports match firebase.json. Never on in
// a production build, whatever the variable says.
if (process.env.REACT_APP_USE_EMULATORS === "true" && process.env.NODE_ENV !== "production") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  // eslint-disable-next-line no-console
  console.info("[Puzzly] using local Firebase emulators");
}

export default app;
